import React from "react";
import { Box, Typography } from "@mui/material";
import { ReadCvLogo } from "@phosphor-icons/react";
import { useTheme } from "@mui/styles";

const Attachment = ({ msg }) => {
  const theme = useTheme();

  const metadata = msg?.metadata;
  if (metadata?.isImage) {
    return (
      <Box
        style={{
          display: "inline-block",
          padding: 4,
          borderRadius: 12,
          border: "1px solid #CDD3DA",
          maxWidth: "100%",
          maxHeight: 400,
          overflow: "hidden",
          marginTop: 12,
        }}
      >
        <img
          src={msg.metadata.attachmentUrl}
          alt="Attachment"
          style={{
            display: "block",
            width: "100%",
            height: "auto",
            maxHeight: 400,
            borderRadius: 12,
            objectFit: "contain",
            cursor: "pointer",
          }}
          onClick={() => window.open(msg.metadata.attachmentUrl, "_blank")}
        />
      </Box>
    );
  } else {
    return (
      <Box
        sx={{
          display: "flex",
          flexDirection: "row",
          padding: "16px",
          gap: "8px",
          justifyContent: "flex-start",
          backgroundColor: "#F6F7F8",
          borderRadius: "12px",
          cursor: "pointer",
          marginTop: "12px",
        }}
        onClick={() => window.open(msg.metadata.attachmentUrl, "_blank")}
      >
        <ReadCvLogo
          size={20}
          weight="duotone"
          color={theme.palette.primary.main}
          style={{
            flexShrink: 0,
            alignSelf: "flex-start",
            height: 20,
            width: 20,
          }}
        />
        <Typography variant="body2">{msg.metadata.filename}</Typography>
      </Box>
    );
  }
};

export default Attachment;
